import React from 'react'
import {Icon} from '@chakra-ui/react'

const AlertIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" id="alert" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.9997 3.21582C20.5486 3.21582 21.0537 3.51564 21.3165 3.99751L37.2225 33.1567C37.476 33.6214 37.4658 34.1854 37.1956 34.6407C36.9253 35.0959 36.4351 35.375 35.9057 35.375H4.09375C3.56434 35.375 3.07413 35.0959 2.80389 34.6407C2.53365 34.1854 2.5234 33.6214 2.77693 33.1567L18.6829 3.99751C18.9457 3.51564 19.4508 3.21582 19.9997 3.21582ZM19.9997 7.84816L6.62064 32.375H33.3788L19.9997 7.84816Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.5 23.8542V14.6042H21.5V23.8542H18.5Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.5 30.0208V26.9375H21.5V30.0208H18.5Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default AlertIcon
